import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import { handleAxiosError, ApiResponse } from "./responses/AxiosResponseHandler";
import UserProfileInfoApiResponse from "./responses/userProfileInfoApiResponse";

class GetUserProfileInfoApi {

    private authClient: AuthClient;
    constructor(authClient: AuthClient) {
        this.authClient = authClient;
    }

    public async getUserProfileInfo(): Promise<ApiResponse<UserProfileInfoApiResponse> | undefined> {

        try {

            const authenticationResponse = this.authClient.getAuthenticationResponse();
            const response = await axios.get(
                `${this.authClient.getApiRoot()}/user/profileInfo`,
                {
                    headers: {
                        Authorization: `Bearer ${authenticationResponse?.token}`,
                    },
                }
            );

            return {
                statusCode: response.status,
                errorMessage: "",
                data: { profileInfo: response.data }
            };

        } catch (error) {
            const errorResponse = handleAxiosError<UserProfileInfoApiResponse>(error as AxiosError);
            return {
                statusCode: errorResponse.statusCode,
                errorMessage: errorResponse.errorMessage,
                data: errorResponse.data
            }
        }
    }
}

export default GetUserProfileInfoApi;